import React, { ReactElement, useMemo } from 'react';
import {
  BsRsvGallery,
  IMediaGalleryItem,
  OverlaySlideInfo,
} from '@hotelplan/core.serving.bs-rsv-gallery';
import {
  FdrImage,
  FdrProductB2bInformationGroup,
} from '@hotelplan/supergraph-api';
import { FdrB2bAdditionalInfo } from 'components/domain/fdr-b2b-additional-info';
import {
  FdrPdpMediaGallery,
  mapFdrMediaToImageMediaItems,
} from 'components/domain/fdr-pdp-media-gallery';
import { renderMedia } from 'components/util/criterias';
import { FdrAdditionalGalleryWrapper } from './fdr-pdp.styles';

interface IFdrRoundTripContentProps {
  images: Array<FdrImage>;
  mapImages: Array<FdrImage>;
  b2bInfoGroups: Array<FdrProductB2bInformationGroup>;
}

export function FdrRoundTripContent({
  images,
  mapImages,
  b2bInfoGroups,
}: IFdrRoundTripContentProps): ReactElement {
  const roundTripMediaItems = useMemo<Array<IMediaGalleryItem>>(() => {
    return mapFdrMediaToImageMediaItems(mapImages);
  }, [mapImages]);

  return (
    <>
      <FdrPdpMediaGallery mediaItems={images} />
      {b2bInfoGroups?.length ? (
        <FdrB2bAdditionalInfo
          b2bInfoGroups={b2bInfoGroups}
          roundTripGallery={
            <>
              {roundTripMediaItems.length ? (
                <FdrAdditionalGalleryWrapper>
                  <BsRsvGallery
                    renderSlide={renderMedia}
                    items={roundTripMediaItems}
                    leftArrow={<></>}
                    rightArrow={<></>}
                    previewIconName={`expand-icon`}
                    className="preview-media-gallery"
                    overlaySlideInfo={item => <OverlaySlideInfo item={item} />}
                  />
                </FdrAdditionalGalleryWrapper>
              ) : null}
            </>
          }
        />
      ) : null}
    </>
  );
}
